import React from 'react'
import './Fallback.css'

const Fallback = () => <div className='Content Fallback'>Denna sidan är under utveckling, var god maila för mer information.</div>

export default Fallback;